const breakpoints = {
    sm : '576',
    md : '768',
    lg : '961'
}

/* ************************************
           Gallery elements
************************************ */

const productBundle = {
    'holder' : document.querySelector('[js-product-bundle]'),
    'content' : document.querySelector('[js-product-bundle]') ? document.querySelector('[js-product-bundle]').innerHTML : null,
    'desktop' : document.querySelector('[js-product-bundle-desktop]'),
    'mobile' : document.querySelector('[js-product-bundle-mobile]'),

    moveToMobile : function() {
        if(this.content){
            this.mobile.innerHTML = this.content;
            this.desktop.innerHTML = '';
        }
    },

    moveToDesktop : function() {
        if(this.content) {
            this.desktop.innerHTML = this.content;
            this.mobile.innerHTML = '';
        }
    },
    defaultPosition : function() {
        if(window.innerWidth < breakpoints.lg) {
            // mobile
            this.moveToMobile();
        }
    }
};


export default productBundle;
